export default __webpack_public_path__ + "static/media/hero.5d0e94c2.jpg";